import React from 'react';

const MarketingSEO = () => {
  return (
    <div style={{ padding: '20px', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
      <h1 style={{ fontSize: '20px', fontWeight: 500, color: '#1A1F36', marginBottom: '14px' }}>🔍 SEO & Google Business Profile</h1>
      <div style={{
        background: 'rgba(255,255,255,0.95)',
        border: '0.5px solid rgba(227,232,238,1)',
        borderRadius: '16px',
        padding: '40px',
        textAlign: 'center',
        boxShadow: '0 1px 0 rgba(255,255,255,1) inset, 0 1px 3px rgba(50,50,93,0.06)'
      }}>
        <div style={{ fontSize: '40px', marginBottom: '12px' }}>🚧</div>
        <p style={{ fontSize: '14px', color: '#697386', margin: 0 }}>Page en construction</p>
      </div>
    </div>
  );
};

export default MarketingSEO;
